export const ClientErrors = {
  NOT_LOGGED_IN: {
    code: '000',
    splunkLabel: 'NOT_LOGGED_IN',
    message: 'Not signed in to sso.',
  },
  INITIALIZATION: {
    code: '001',
    splunkLabel: 'INITIALIZATION',
    message: 'Error initializing the client library.',
  },
  IAM_SYNC: {
    code: '002',
    splunkLabel: 'IAM_SYNC',
    message: 'Error retrieving iam configuration.',
  },
  TOKEN_SYNC: {
    code: '003',
    splunkLabel: 'TOKEN_SYNC',
    message: 'Error syncing login state with the sso server.',
  },
  // getIdToken re-logs a token sync failure that MyStorage has already logged.
  // It carries extra call-site context, so it keeps its own label rather than
  // reusing TOKEN_SYNC and double-counting every sync failure in Splunk.
  TOKEN_SYNC_GET_ID_TOKEN: {
    code: '041',
    splunkLabel: 'TOKEN_SYNC_GET_ID_TOKEN',
    message: 'Token sync failure surfaced to getIdToken (already logged).',
  },
  TOKEN_SYNC_HTTP_ERROR: {
    code: '039',
    splunkLabel: 'TOKEN_SYNC_HTTP_ERROR',
    message: 'Token sync returned unexpected HTTP status from the sso server.',
  },
  TOKEN_SYNC_NO_CONTENT: {
    code: '040',
    splunkLabel: 'TOKEN_SYNC_NO_CONTENT',
    message: 'Token sync returned 204 no content - user not logged in.',
  },
  INVALID_COGNITO_SESSION: {
    code: '004',
    splunkLabel: 'INVALID_COGNITO_SESSION',
    message: 'Error retrieving a valid session token from cognito.',
  },
  APP_SERVER_SESSION_POLL: {
    code: '006',
    splunkLabel: 'APP_SERVER_SESSION_POLL',
    message: 'Error communicating with app server.',
  },
  TEST_AND_TARGET_BAILOUT: {
    code: '007',
    splunkLabel: 'TEST_AND_TARGET_BAILOUT',
    message: 'Bailed out on Test and Target.',
  },
  EXTEND_PERSIST_COOKIE_ERROR: {
    code: '008',
    splunkLabel: 'EXTEND_PERSIST_COOKIE_ERROR',
    message: 'Error communicating with sso server to extend cookie life.',
  },
  CHECK_COOKIE_EXISTENCE: {
    code: '009',
    splunkLabel: 'CHECK_COOKIE_EXISTENCE',
    message: 'Error communicating with sso server to check cookie life.',
  },
  CURRENT_AUTH_USER_EXCEPTION: {
    code: '012',
    splunkLabel: 'CURRENT_AUTH_USER_EXCEPTION',
    message: 'Amplify error while calling currentAuthenticatedUser method.',
  },
  CURRENT_USER_EMAIL_MISMATCH: {
    code: '013',
    splunkLabel: 'CURRENT_USER_EMAIL_MISMATCH',
    message:
      'User mismatch on getIdToken call. Zuul would have called window.reload() for this condition.',
  },
  COOKIE_HTML_DATA_ERROR: {
    code: '014',
    splunkLabel: 'COOKIE_HTML_DATA_ERROR',
    message: 'Received something other than an email from postMessage.',
  },
  TRACKER_FAILED: {
    code: '015',
    splunkLabel: 'TRACKER_FAILED',
    message: 'Code for user tracking info had an uncaught error.',
  },
  SIGN_NO_REDIRECT_RESYNC_TOKENS_FAILED: {
    code: '016',
    splunkLabel: 'SIGN_NO_REDIRECT_RESYNC_TOKENS_FAILED',
    message: 'The execution of resyncTokens from the sign in popup failed.',
  },
  SIGN_NO_REDIRECT_RESYNC_TOKENS_UNRESOLVED: {
    code: '017',
    splunkLabel: 'SIGN_NO_REDIRECT_RESYNC_TOKENS_UNRESOLVED',
    message:
      'The execution of resyncTokens from the sign in popup seem to have never resolved.',
  },
  GUEST_LOGIN_FAILED: {
    code: '018',
    splunkLabel: 'GUEST_LOGIN_FAILED',
    message: 'Error in Guest login api.',
  },
  GUEST_TOKEN_SYNC: {
    code: '019',
    splunkLabel: 'GUEST_TOKEN_SYNC',
    message: 'Error syncing guest token for coookies creation.',
  },
  GUEST_USER_ALREADY_LOGGED_IN: {
    code: '020',
    splunkLabel: 'USER_ALREADY_LOGGED_IN',
    message: 'User is already loggedin while Guest login',
  },
  GUEST_REDIRECT_URI_NOT_FOUND: {
    code: '021',
    splunkLabel: 'GUEST_REDIRECT_URI_NOT_FOUND',
    message: 'Please provide Guest redict uri.',
  },
  GUEST_LOGIN_INITIALIZATION: {
    code: '022',
    splunkLabel: 'GUEST_LOGIN_INITIALIZATION',
    message: 'Error initializing the client library.',
  },

  GET_PREFERENCES_FAILED: {
    code: '023',
    splunkLabel: 'GET_PREFERENCES_FAILED',
    message: 'Error in the Get preferences api.',
  },

  POST_PREFERENCES_API_FAILED: {
    code: '024',
    splunkLabel: 'POST_PREFERENCES_API_FAILED',
    message: 'Error in the saving preferences cookies api.',
  },

  AIRGAP_ERROR: {
    code: '025',
    splunkLabel: 'AIRGAP_ERROR',
    message: 'Error while getting the airgap consent',
  },

  GET_DATA_LAYER_FAILED: {
    code: '026',
    splunkLabel: 'GET_DATA_LAYER_FAILED',
    message: 'Error in the get datalayer api.',
  },

  GET_DATA_LAYER_NON_SUCCESS_STATUS: {
    code: '027',
    splunkLabel: 'GET_DATA_LAYER_NON_SUCCESS_STATUS',
    message: 'Error in the get datalayer api as getting non success status.',
  },
  FORCE_RESYNC_TOKENS_EXCEPTION: {
    code: '030',
    splunkLabel: 'FORCE_RESYNC_TOKENS_EXCEPTION',
    message: 'Error in sync api while forcefully resync token.',
  },

  FORCE_RESYNC_TOKENS_GET_ID_TOKEN_EXCEPTION: {
    code: '031',
    splunkLabel: 'FORCE_RESYNC_TOKENS_GET_ID_TOKEN_EXCEPTION',
    message: 'Error in getIDToken for forcefully resync token.',
  },

  // A resync that ends with the user logged out (e.g. /sync returned 204) is an
  // expected state, not a failure, so it is logged as a warning under its own
  // label to keep it out of the FORCE_RESYNC_TOKENS_GET_ID_TOKEN_EXCEPTION count.
  FORCE_RESYNC_TOKENS_NOT_LOGGED_IN: {
    code: '044',
    splunkLabel: 'FORCE_RESYNC_TOKENS_NOT_LOGGED_IN',
    message: 'User not logged in after forcefully resync token.',
  },

  EMAIL_MISMATCH_RESYNC_TOKENS_FAILED: {
    code: '032',
    splunkLabel: 'EMAIL_MISMATCH_RESYNC_TOKENS_FAILED',
    message:
      'resyncTokens failed after a current user email mismatch. Reloading the page.',
  },

  BRAND_OTP_SIGNIN_EMAIL_REQUIRED: {
    code: '033',
    splunkLabel: 'BRAND_OTP_SIGNIN_EMAIL_REQUIRED',
    message: 'Email is required to start the brand OTP sign in flow.',
  },

  BRAND_OTP_SIGNIN_BRAND_REQUIRED: {
    code: '034',
    splunkLabel: 'BRAND_OTP_SIGNIN_BRAND_REQUIRED',
    message: 'Brand is required to start the brand OTP sign in flow.',
  },

  BRAND_OTP_SIGNIN_FAILED: {
    code: '035',
    splunkLabel: 'BRAND_OTP_SIGNIN_FAILED',
    message: 'Error sending the brand OTP sign in challenge code.',
  },

  BRAND_OTP_SIGNIN_INVALID_CAPTCHA_TEXT: {
    code: '036',
    splunkLabel: 'BRAND_OTP_SIGNIN_INVALID_CAPTCHA_TEXT',
    message:
      'Incorrect challenge text while sending the brand OTP sign in code.',
  },

  BRAND_OTP_SIGNIN_RECAPTCHA_CHALLENGE: {
    code: '037',
    splunkLabel: 'BRAND_OTP_SIGNIN_RECAPTCHA_CHALLENGE',
    message:
      'Recaptcha image challenge required while sending the brand OTP sign in code.',
  },

  BRAND_OTP_SIGNIN_ALREADY_LOGGED_IN: {
    code: '038',
    splunkLabel: 'BRAND_OTP_SIGNIN_ALREADY_LOGGED_IN',
    message:
      'User is already logged in while starting the brand OTP sign in flow.',
  },

  HTTP_TIMEOUT: {
    code: '041',
    splunkLabel: 'HTTP_TIMEOUT',
    message: 'Request timed out.',
  },

  HTTP_NETWORK_ERROR: {
    code: '042',
    splunkLabel: 'HTTP_NETWORK_ERROR',
    message: 'Network error while calling the identity service.',
  },

  // The cookie sync after a refresh-token call is a fire-and-forget side effect,
  // so its failures are logged as warnings and otherwise ignored.
  TOKEN_SYNC_AFTER_REFRESH: {
    code: '043',
    splunkLabel: 'TOKEN_SYNC_AFTER_REFRESH',
    message: 'Cookie sync after a refresh-token call failed (ignored).',
  },
};
